<template>
    <GenericItem
        :labels="getLabels()"
        :actions="getActions()"
        :is-square="isSquare"
        is-labels-compact>
        <template v-slot:custom>
            <div class="uk-flex uk-flex-center">
                <div
                    v-if="store.imageId"
                    :data-src="getImageLink()"
                    :class="isSquare ? '' : 'item-thumbnail-round'"
                    class="item-thumbnail uk-background-cover"
                    uk-img />
                <div
                    v-else
                    :class="isSquare ? '' : 'item-thumbnail-round'"
                    class="item-thumbnail item-thumbnail-initials">
                    {{ getInitials(store.name) }}
                </div>
            </div>

            <div class="uk-margin-small-top item-title">
                {{ store.name }}
            </div>

            <div class="uk-margin-top" />
        </template>
    </GenericItem>
</template>

<script>
import GenericItem from '@/components/generic/GenericItem';

export default {
    name: 'StoreItem',
    components: {GenericItem},
    props: {
        store: Object,
        isSquare: Boolean,
    },
    methods: {
        getInitials(name) {
            if (!name) {
                return '?';
            }

            return name
                .trim()
                .split(/\s+/)
                .slice(0, 2)
                .map((word) => word[0].toUpperCase())
                .join('');
        },
        getImageLink() {
            const parts = this.store.imageId.split('_');

            return (
                this.apiUrl +
                '/stores/' +
                this.store.id +
                '/image/' +
                parts.slice(1).join('_')
            );
        },
        getLabels() {
            let labels = [];

            labels.push({
                mode: 'default',
                icon: 'location',
                name:
                    this.store.street +
                    ', ' +
                    this.store.zip +
                    ' ' +
                    this.store.city,
                tooltip: this.$t('address'),
            });

            labels.push({
                mode: 'default',
                icon: 'mail',
                name: this.store.email,
                tooltip: this.$t('emailAddress'),
            });

            if (this.store.telephone) {
                labels.push({
                    mode: 'default',
                    icon: 'receiver',
                    name: this.store.telephone,
                    tooltip: this.$t('telephone'),
                });
            }

            return labels;
        },
        getActions() {
            return [
                {
                    name: this.$t('edit'),
                    mode: 'theme',
                    icon: 'settings',
                    function: () => this.$emit('select', this.store),
                },
                {
                    name: this.$t('delete'),
                    mode: 'danger',
                    icon: 'trash',
                    function: () => this.$emit('delete', this.store),
                },
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
.item-thumbnail {
    height: 100px;
    width: 100px;
}

.item-thumbnail-round {
    border-radius: $border-radius-next;
}

.item-title {
    font-size: 17px;
    font-weight: 500;
}

.item-thumbnail-initials {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #14183b;
    color: #fff;
    font-size: 1.25rem;
    font-weight: 500;
    letter-spacing: 0.05em;
    user-select: none;
}
</style>
